
<div class="d-flex gap-2 justify-content-center m-1">
  
  <!-- Edit Button -->
  <button class="btn btn-sm btn-outline-primary"  (click)="onEdit()" [title]="editLabel">
    <i class="bi" [ngClass]="editIcon"></i>
  </button>

  <!-- Details Button -->
  <!-- <button class="btn btn-sm btn-outline-info" (click)="onDetails()" [title]="detailsLabel">
    <i class="bi" [ngClass]="detailsIcon"></i>
  </button> -->

  <!-- Delete Button -->
  <button class="btn btn-sm btn-outline-danger" disableIfNoGroupPermission (click)="onDelete()" [title]="deleteLabel">
    <i class="bi" [ngClass]="deleteIcon"></i>
  </button>

</div>